import { render, staticRenderFns } from "./PanelBackgroundColorSelector.vue?vue&type=template&id=0db50258&scoped=true"
import script from "./PanelBackgroundColorSelector.vue?vue&type=script&lang=js"
export * from "./PanelBackgroundColorSelector.vue?vue&type=script&lang=js"
import style0 from "./PanelBackgroundColorSelector.vue?vue&type=style&index=0&id=0db50258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db50258",
  null
  
)

export default component.exports